import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myservicefilter',
    pure: false
})
export class MyServiceFilterPipe implements PipeTransform {
    transform(items: any[], conditions: any): any {
        return conditions ? items.filter(item =>
            item.AssignmentStatusId == conditions.statusId &&
            item.ProfileName.toLowerCase().indexOf(conditions.name.toLowerCase()) > -1) : items;
    }
}